import { render, staticRenderFns } from "./OnboardingErrorGeneric.vue?vue&type=template&id=27537ef0&scoped=true"
import script from "./OnboardingErrorGeneric.vue?vue&type=script&lang=js"
export * from "./OnboardingErrorGeneric.vue?vue&type=script&lang=js"
import style0 from "./OnboardingErrorGeneric.vue?vue&type=style&index=0&id=27537ef0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27537ef0",
  null
  
)

export default component.exports